import axios from "axios";
import AdManagerAdvertisingZoneGroupEditDialog from "@/components/AdManager/AdManagerAdvertisingZoneGroupEditDialog/AdManagerAdvertisingZoneGroupEditDialog.vue";
import { getTokenHeader } from "@/helpers/commonHelper";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "AdManagerAdvertisingZoneGroup",
  components: {
    AdManagerAdvertisingZoneGroupEditDialog
  },
  data: () => ({
    headers: [
      { text: "Name", value: "name" },
      { text: "Werbezonen", value: "zones", sortable: false },
      {
        text: "Aktionen",
        value: "actions",
        sortable: false,
        align: "center",
        width: "5%"
      }
    ],
    groups: [],
    zones: [],
    total: 0,
    itemsPerPage: 10,
    options: {},
    loading: true,
    mainPeacock: "#00636C",
    mainRed: "#A60F0F",
    page: 1,
    pageCount: 0,
    search: "",
    editDialog: false,
    editedItem: null
  }),
  async mounted() {
    await this.$store.dispatch("getPrincipals");
    await this.loadZones();
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal?.id;
    }
  },
  methods: {
    nextPage() {
      const totalPages = Math.ceil(this.total / this.itemsPerPage);
      if (this.page < totalPages) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    getSearchParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      return {
        query: this.search,
        principal_id: this.currentPrincipal,
        limit: itemsPerPage,
        offset: (page - 1) * itemsPerPage,
        sort: sortBy?.[0] || "name",
        direction: sortDesc?.[0] ? "desc" : "asc"
      };
    },
    async loadZones() {
      const headers = getTokenHeader();
      const r = await axios.get(env.ad_manager_api_client_url + "ad/zones", {
        headers,
        params: {
          limit: 999
        }
      });
      this.zones = r.data || [];
    },
    async loadGroups() {
      const headers = getTokenHeader();
      this.loading = true;
      try {
        const r = await axios.get(env.ad_manager_api_client_url + "ad/groups", {
          headers,
          params: this.getSearchParams()
        });
        this.groups = r.data || [];
        const count = parseInt(r?.headers?.["x-count"]);
        this.total = isNaN(count) ? this.groups.length : count;
      } finally {
        this.loading = false;
      }
    },
    createItem() {
      this.editedItem = {
        _id: "",
        principal_id: this.currentPrincipal,
        zones: []
      };
      this.editDialog = true;
    },
    editItem(item) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editDialog = true;
    },
    async deleteItem(item) {
      const ok = await this.$confirm?.(
        `Werbezone <b>${item.name}</b> wirklich löschen?`,
        confirmWarningConfig
      );
      if (!ok) return;
      const headers = getTokenHeader();
      await axios.delete(
        env.ad_manager_api_client_url + "ad/groups/" + item._id,
        {
          headers,
          params: { principal_id: this.currentPrincipal }
        }
      );

      await this.loadGroups();
      await this.$store.dispatch("createSuccess", "Werbezonengruppe gelöscht");
    },
    async afterSave() {
      await this.loadGroups();
      await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert");
    },
    close() {
      this.editDialog = false;
      this.$nextTick(() => (this.editedItem = null));
    }
  },
  watch: {
    options() {
      this.loadGroups();
    },
    search(val) {
      if (val?.length >= 3 || val === "") this.loadGroups();
    },
    currentPrincipal() {
      this.loadZones();
      this.loadGroups();
    }
  }
};
